import type { ReactNode } from "react";

export interface EmptyProps {
  title?: ReactNode;
  children?: ReactNode;
  icon?: ReactNode;
}

export function Empty({ title, children, icon }: EmptyProps) {
  return (
    <div className="card empty">
      {(title || icon) && (
        <div className="empty-title">
          {icon}
          {title && <span style={{ marginLeft: icon ? 6 : 0 }}>{title}</span>}
        </div>
      )}
      {children}
    </div>
  );
}
